export default (that) => [
  {
    text: that.$l('menu_text_edit') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: false,
    allow: 'M',
    disabled: ({ amzFlipOrderSkuStatus }) =>
      !(
        amzFlipOrderSkuStatus == 'N' ||
        amzFlipOrderSkuStatus == 'C' ||
        amzFlipOrderSkuStatus == 'R'
      ),
  },
  {
    text: that.$l('menu_text_delete_sku') || '删除SKU',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    disabled: ({ amzFlipOrderSkuStatus }) =>
      !(amzFlipOrderSkuStatus == 'N' || amzFlipOrderSkuStatus == 'R'),
  },
  {
    text: that.$l('menu_text_review') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'review',
    divided: true,
    allow: 'R',
    disabled: ({ amzFlipOrderSkuStatus }) =>
      !(amzFlipOrderSkuStatus == 'C' || amzFlipOrderSkuStatus == 'R'|| amzFlipOrderSkuStatus == 'N'),
  },
  // {
  //   text: that.$l('btn_submit_confirmOrder') || '翻单确认',
  //   icon: 'el-icon-check',
  //   menuType: 'confirmOrder',
  //   divided: false,
  //   allow: 'O',
  //   disabled: ({ amzFlipOrderSkuStatus }) => !(amzFlipOrderSkuStatus == 'N'),
  // },
]
